const getExplorerTxLink = (blockchain: string, txHash: string): string => {
	const explorers: Record<string, string> = {
		TON: 'https://tonviewer.com/transaction', // TON viewer
		BSC: 'https://bscscan.com/tx', // Binance Smart Chain
		ETH: 'https://etherscan.io/tx', // Ethereum
		ETHEREUM: 'https://etherscan.io/tx', // Ethereum
		POLYGON: 'https://polygonscan.com/tx', // Polygon
		ARB: 'https://arbiscan.io/tx', // Arbitrum
		ARBITRUM: 'https://arbiscan.io/tx', // Arbitrum
		BASE: 'https://basescan.org/tx', // Base
		ASSET: 'https://explorer.assetchain.org/tx', // Hypothetical AssetChain explorer
		ASSETCHAIN: 'https://explorer.assetchain.org/tx', // Hypothetical AssetChain explorer
	};

	const baseUrl = explorers[blockchain.toUpperCase()];
	if (!baseUrl) {
		console.warn(`Unknown blockchain: ${blockchain}`);
		return '#';
	}

	return `${baseUrl}/${txHash}`;
};

export default getExplorerTxLink;
